import { render, staticRenderFns } from "./ReporteRondasPrepagadas.vue?vue&type=template&id=20b0985d"
import script from "./ReporteRondasPrepagadas.vue?vue&type=script&lang=js"
export * from "./ReporteRondasPrepagadas.vue?vue&type=script&lang=js"
import style0 from "./ReporteRondasPrepagadas.vue?vue&type=style&index=0&id=20b0985d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports